function parseFacetVisibility(facets = [], filterParam = '') {
  const sanitizedParams = filterParam?.split(/,|%2C/).filter(Boolean) ?? [];

  const visibleFacets = facets.filter((_) => _.visible).map((_) => _.facet);
  const hiddenFilterParams = sanitizedParams?.filter(
    (sanitizedParam) => !visibleFacets.some((vf) => sanitizedParam.includes(vf))
  );
  const visibleFilterCount =
    sanitizedParams?.filter((sanitizedParam) =>
      visibleFacets.some((facet) => sanitizedParam.includes(facet))
    )?.length ?? 0;

  return { hiddenFilterParams, sanitizedParams, visibleFilterCount };
}

export default parseFacetVisibility;
